import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          margin: 0,
          padding: 0,
          height: '100%',
        },
        body: {
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          color: '#F1F7F7',
          backgroundColor: '#021a1a',
        },
        p: {
          margin: 0,
        },
        h1: {
          margin: 0,
        },
        h2: {
          margin: 0,
        },
        h3: {
          margin: 0,
        },
        h4: {
          margin: 0,
        },
        h5: {
          margin: 0,
        },
        h6: {
          margin: 0,
        },
      },

    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Poppins', sans-serif",
        },
      },
    },
  },
}); 